module.exports = __webpack_public_path__ + "static/img/合约交易_图2.e925fad0.png";